<div class="skin-black fixed sidebar-fixed" [ngClass]="rendererService.config.menu ? 'sidebar-fixed' : 'layout-top-nav'" style="height: auto; min-height: 100%;">
    <div class="wrapper" style="height: auto; min-height: 100%;">
        <!--    <app-main-header [CurrentUser]="CurrentUser" [UserIsLoad]="userIsload" ></app-main-header>-->
        <app-main-header></app-main-header>
        <app-main-sidebar *ngIf="rendererService.config.menu"></app-main-sidebar>
        <div class="content-wrapper" style="min-height: 960px; padding-top: 50px; padding-right:0px; padding-bottom: 0px; margin-bottom:0px; height:100%">
            <router-outlet></router-outlet>
        </div>
        <app-main-footer></app-main-footer>
    </div>
</div>